import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FiltersModel } from 'src/app/shared/models/FiltersModel.model';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';
import { KioskMoneyTransactionListModel } from 'src/app/shared/models/kiosk-money-transaction-list-model';

@Injectable({
  providedIn: 'root'
})
export class KioskMoneyTransactionService {

  private userToken: string;

  constructor(private http: HttpClient, private authenticationService: AuthenticationService) {
    const $this = this;
    $this.userToken = $this.authenticationService.currentUserValue.Token;
  }

  public GetAllColumnNames(): Observable<string[]> {
    const $this = this;

    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + $this.userToken)
    }

    return $this.http.get<string[]>(environment.apiUrl + 'api/v1/KioskMoneyTransaction/GetAllColumnNames', header).pipe();
  }

  public GetAllKioskMoneyTransactions(filterParameters: FiltersModel): Observable<KioskMoneyTransactionListModel> {
    const $this = this;

    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + $this.userToken)
    }

    return $this.http.post<KioskMoneyTransactionListModel>(environment.apiUrl + 'api/v1/KioskMoneyTransaction/GetKioskMoneyTransactions', filterParameters, header).pipe();
  }
}
